/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DutyScheduleDisplayStatus = {
    InProgress: 'InProgress',
    Released: 'Released',
    Current: 'Current'
} as const;
export type DutyScheduleDisplayStatus = typeof DutyScheduleDisplayStatus[keyof typeof DutyScheduleDisplayStatus];


export function instanceOfDutyScheduleDisplayStatus(value: any): boolean {
    for (const key in DutyScheduleDisplayStatus) {
        if (Object.prototype.hasOwnProperty.call(DutyScheduleDisplayStatus, key)) {
            if (DutyScheduleDisplayStatus[key as keyof typeof DutyScheduleDisplayStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DutyScheduleDisplayStatusFromJSON(json: any): DutyScheduleDisplayStatus {
    return DutyScheduleDisplayStatusFromJSONTyped(json, false);
}

export function DutyScheduleDisplayStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleDisplayStatus {
    return json as DutyScheduleDisplayStatus;
}

export function DutyScheduleDisplayStatusToJSON(value?: DutyScheduleDisplayStatus | null): any {
    return value as any;
}

export function DutyScheduleDisplayStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DutyScheduleDisplayStatus {
    return value as DutyScheduleDisplayStatus;
}

